<template>
    <v-layout class="mt-3">
        <v-flex xs12>
            <confirmation-header-text text="Academic Institution" class="ml-2"
                                      icon="mdi-school"></confirmation-header-text>
            <v-card-text>
                <v-layout class row>
                    <v-flex md4 xs12>
                        <v-text-field
                                label="Address of Institution"
                                outlined
                                type="text"
                                v-model="visa.extra.application_data.name_of_academic_institution"
                        ></v-text-field>
                    </v-flex>
                    <v-flex md4 xs12 class="px-2">
                        <v-text-field
                                label="Subject to Study"
                                outlined
                                type="text"
                                v-model="visa.extra.application_data.subject"
                        ></v-text-field>
                    </v-flex>
                    <v-flex md4 xs12>
                        <address-auto-complete
                                label="Address of Institution"
                                country-code="np"
                                v-model="visa.extra.application_data.institute_address"
                        ></address-auto-complete>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-flex>
    </v-layout>
</template>

<script>
    import AddressAutoComplete from "../../AddressAutoComplete";
    import ConfirmationHeaderText from "../../ConfirmationHeaderText";


    export default {
        data: () => ({
            rules: {
                required: value => !!value || "Required."
            },
            rfdialogmodal: false,
            options: [
                {
                    text: "Nepal",
                    value: "Nepal"
                },
                {
                    text: "Abroad",
                    value: "Abroad"
                }
            ]
        }),
        components: {
            "address-auto-complete": AddressAutoComplete, ConfirmationHeaderText
        },
        computed: {
            visa() {
                        return this.$store.state.VisaRequestSingle.visaRequest;
                }
        },
        methods: {
            addressChanged(e) {
                this.visa.extra.application_data.institute_address = e;
            }
        }
    };
</script>

<style>
</style>
